module.exports = __webpack_public_path__ + "img/93.4ac18c3e.jpg";